import { useEffect } from 'react';
import { ListboxList as ListboxList$1, useListboxContext } from '@reach/listbox';
import { createComponent } from '../core/create-component.js';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noOp = () => {};
const ListboxList = createComponent({
  displayName: 'ListboxList',
  root: ListboxList$1,
  propConfig: {
    classNames: ['swan-listbox-list'],
    derivedProps() {
      const {
        selectedOptionRef,
        isExpanded,
        highlightedOptionRef,
        id
      } = useListboxContext();
      // Ensure that the selected item is in view when opening the popover
      useEffect(() => {
        if (selectedOptionRef.current && isExpanded) {
          selectedOptionRef.current.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        }
      }, [isExpanded]);
      // Ensure that the highlighted item is in view at all times when using keyboard
      useEffect(() => {
        if (!isExpanded) return noOp;
        const ensureHighlightedInView = e => {
          if (highlightedOptionRef.current) {
            highlightedOptionRef.current.scrollIntoView({
              block: 'nearest',
              behavior: 'smooth'
            });
          }
          if (e.key === 'Tab' || e.code === 'Tab' || e.which === 9) {
            var _document_getElementById;
            (_document_getElementById = document.getElementById("button--".concat(id))) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
            e.preventDefault();
          }
        };
        window.addEventListener('keydown', ensureHighlightedInView);
        return () => {
          window.removeEventListener('keydown', ensureHighlightedInView);
        };
      }, [id, isExpanded]);
      return null;
    }
  }
});
export { ListboxList };